module.exports = __webpack_public_path__ + "img/error.60ef70c7.svg";